import coinCoreInfo from '../widgets/coinCoreInfo.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await coinCoreInfo.updateDynamicsData();
    });
}(jQuery));